module.exports = __webpack_public_path__ + "img/Ford-Plaze-BG.c20250ce.jpg";